module.exports = __webpack_public_path__ + "img/Intelligence.420bcff5.svg";